import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Drawer } from '~/components';
import { Alert, Typography } from 'antd';
import styled from 'styled-components';
import theme from '~/theme';
import { GuideCSV } from '~/img';
import layout from '~/hooks/layout';
import { useDirection } from '~/hooks';
// @ts-ignore
import templateFile from '~/img/payrolls/TEMPLATE.csv';

interface Props {
  open: boolean;
  className?: string;
  onClose: () => void;
}

const GuideDrawer: FC<Props> = (props) => {
  const { open, onClose } = props;
  const [t] = useTranslation('payrolls');
  const isMobile = layout.useIsMobile();

  return (
    <Drawer title={t('User guide to payroll')} onClose={onClose} open={open} size="large">
      <Alert
        type="warning"
        showIcon
        message={
          <div>
            <Trans ns="payrolls" i18nKey="payrollBatchCurrencyNote" components={{ br: <br /> }} />
          </div>
        }
        style={{ marginBottom: 16 }}
      />
      <Step number={1}>
        <Trans ns="payrolls" i18nKey="downloadTemplate">
          {'Download the '}
          <a download="TEMPLATE.csv" href={templateFile}>
            CSV template
          </a>
        </Trans>
      </Step>
      <Step number={2}>
        <div>
          <Typography.Text>{t('Fill in the following data for each beneficiary')}</Typography.Text>
        </div>
        <ul>
          <li>
            <Typography.Text strong>
              {t(
                'Account number or phone number (format ‘P_’, then country code and rest of number, e.g. ‘P_971501234567’)'
              )}
            </Typography.Text>
          </li>
          <li>
            <Typography.Text strong>{t('Transfer amount')}</Typography.Text>
          </li>
          <li>
            <Typography.Text strong>{t('Full name')}</Typography.Text>
          </li>
          <li>
            <Typography.Text strong>{t('Payment description')}</Typography.Text>
          </li>
        </ul>
        <div>
          <Trans ns="payrolls" defaults="enterDetails" />
        </div>
        <GuideCSV style={{ width: isMobile ? '100%' : '80%' }} />
      </Step>
      <Step number={3}>
        <Typography.Text>{t('Click "Run Payroll" button to start the flow.')}</Typography.Text>
      </Step>
      <Step number={4}>
        <Typography.Text>
          {t('Select the account to debit and enter the required details and upload the CSV file.')}
        </Typography.Text>
      </Step>
      <Step number={5}>
        <Trans ns="payrolls" defaults="readyToPayStatus" />
        <br />
        <Typography.Text>
          {t('In case of any errors fix the document data and re-upload the file.')}
        </Typography.Text>
      </Step>
      <Step number={6}>
        <Typography.Text>
          {t('Verify your transfer details and complete the operation.')}
        </Typography.Text>
      </Step>
    </Drawer>
  );
};

interface StepProps {
  number: number;
}

const Step: FC<StepProps> = (props) => {
  const { number, children } = props;
  const [dir] = useDirection();
  return (
    <Container dir={dir}>
      <div className="Step-NumberContainer">
        <Typography.Text>{number}</Typography.Text>
      </div>
      <div className="Step-Content">{children}</div>
    </Container>
  );
};

export default GuideDrawer;

const Container = styled.div`
  display: flex;
  margin-bottom: 16px;

  .Step-NumberContainer {
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background-color: ${theme.primaryColor};
    display: flex;
    justify-content: center;
    margin-right: ${({ dir }) => (dir === 'ltr' ? '16px' : '0')};
    margin-left: ${({ dir }) => (dir === 'ltr' ? '0' : '16px')};

    .ant-typography {
      color: #fff;
    }
  }

  .Step-Content {
    width: 100%;
  }
`;
